import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { Observable } from 'rxjs';

import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import { NgRxState, Action } from '@roi/common/stored/global';

import { Languages } from '../../public/i18n';

import { environment } from '../environments/environment';
import { OidcToolService } from '@roi/common/services/tools/oidc-tool.service';

export function Initialize(): Observable<void> {
  const initializeService = inject(InitializeService);

  return initializeService.initialize();
}

@Injectable({ providedIn: 'root' })
export class InitializeService {
  private title = inject(Title);
  private ngrxStore = inject(Store<NgRxState>);
  private translateService = inject(TranslateService);
  private oidcToolService = inject(OidcToolService);

  public initialize(): Observable<void> {
    this.ngrxStore.dispatch(Action.AppAction.SetStart());
    console.info('App start:', new Date().toISOString());

    return new Observable((subscriber) => {
      if (!environment.production) {
        this.title.setTitle(`${this.title.getTitle()} (${environment.mode})`);
      }

      this.localization('th_TH');

      const localUserValue = localStorage.getItem('user');
      if (localUserValue) {
        const user = JSON.parse(localUserValue);
        this.ngrxStore.dispatch(
          Action.AuthAction.SetToken({ token: user.token, ready: true })
        );
      } else {
        this.ngrxStore.dispatch(
          Action.AuthAction.SetToken({ token: '', ready: false })
        );
      }

      // this.oidcToolService.config();
      // this.oidcToolService.oauth
      //   .loadDiscoveryDocumentAndTryLogin()
      //   .then(async (value) => {
      //     // 3) once logged in, set up silent refresh
      //     this.oidcToolService.oauth.setupAutomaticSilentRefresh();

      //     if (
      //       !this.oidcToolService.oauth.hasValidIdToken() ||
      //       !this.oidcToolService.oauth.hasValidAccessToken()
      //     ) {
      //        await this.oidcToolService.oauth.loadDiscoveryDocumentAndLogin();
      //     }
      //   });

      subscriber.complete();
    });
  }

  private localization(language: string): void {
    Languages.forEach((value) => {
      this.translateService.addLangs([
        ...this.translateService.getLangs(),
        value.language,
      ]);

      this.translateService.setTranslation(value.language, value.translation);
    });

    this.translateService.setDefaultLang('en_US');
    const saved = localStorage.getItem('lang');
    localStorage.setItem('lang', saved || language);
    this.translateService.use(saved || language);
  }
}
